import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a427be04&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a427be04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/shenyang-xcommunity-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a427be04')) {
      api.createRecord('a427be04', component.options)
    } else {
      api.reload('a427be04', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a427be04&scoped=true", function () {
      api.rerender('a427be04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYSelectCustomerInput/index.vue"
export default component.exports